import React from 'react';
import { Link } from 'react-router-dom';
import EmptyState from './EmptyState';
import PageHeader from './PageHeader';

const mapIconColorToTone = (iconColor) => {
  switch (iconColor) {
    case 'text-success':
      return 'success';
    case 'text-warning':
      return 'warning';
    case 'text-info':
      return 'info';
    case 'text-danger':
      return 'danger';
    case 'text-secondary':
      return 'secondary';
    default:
      return 'primary';
  }
};

const PlaceholderPage = ({ 
  title, 
  icon, 
  description, 
  iconColor = 'text-tse-primary'
  // breadcrumbTitle 
}) => {
  const iconTone = mapIconColorToTone(iconColor);

  return (
    <>
      {/* Breadcrumb */}
{/*       <nav aria-label="breadcrumb" className="mb-4">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Dashboard</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {breadcrumbTitle || title}
          </li>
        </ol>
      </nav> */}

      <PageHeader
        eyebrow="TriServe Workspace"
        title={title}
        description={description}
        icon={icon}
        iconTone={iconTone}
        className="mb-4"
      />

      {/* Content Card */}
      <div className="row">
        <div className="col-12">
          <EmptyState
            icon={icon}
            eyebrow="Feature Preview"
            title="Coming Soon"
            message="This feature is currently under development and will be available in a future update."
            actions={(
              <>
                <Link to="/dashboard" className="btn btn-tse-primary">
                  <i className="bi bi-house me-2"></i>Return to Dashboard
                </Link>
                <button className="btn btn-outline-secondary" disabled>
                  <i className="bi bi-bell me-2"></i>Notify When Ready
                </button>
              </>
            )}
          />
        </div>
      </div>
    </>
  );
};

export default PlaceholderPage;
